export default function ownerDocument(node) {
  return node && node.ownerDocument || document;
}


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/utils/ownerDocument.js
// module id = 161
// module chunks = 121